import { HIDE_MESSAGE, SHOW_MESSAGE } from "./actionType";

const initialState = {
    show:false,
    message:'',
    title:'',
}

export default (state = initialState, { type, payload }) => {
    switch (type) {

    case SHOW_MESSAGE:
        return { ...state, show:true, message:payload.message,title:payload.title}
    case HIDE_MESSAGE:
        return { ...state, show:false,message:'',title:'' }

    default:
        return state
    }
}
